import instance from "@/plugins/request";
import { ResponseData } from "@/interface/request";

// data: 在request body
// params 自动拼接url
// 获取区域列表
export const getShopList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/client/area/areaList",
    method: "get",
    params: params
  });
};
// 获取区域列表  !!!! 获取父级的父级的信息
export const getZones = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: `/manage/area/area`,
    method: "get",
    params: params
  });
};

// 用户是否有权限访问数据
export const getPageAuth = (params: number): Promise<ResponseData> => {
  return instance.request({
    url: "/h5/getRouters/" + params,
    method: "get"
  });
};

//获得用户列表
export const getUserList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/system/user/list",
    method: "get",
    params
  });
};
// 登录
export const login = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/login",
    method: "post",
    data
  });
};

//获得SSO验证地址
export const getSSOUrl = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/getSSOUrl",
    method: "get",
    params,
    headers: {
      Authorization: null
    }
  });
};
export const loginSSO = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/loginSSO",
    method: "post",
    data: params
  });
};
export const getInfo = () => {
  return instance.request({
    url: "/getInfo",
    method: "get"
  });
};

export const getLogList = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/manage/insertBranch/loginLogList",
    method: "get",
    params
  });
};

export const getLogDownLoad = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/manage/insertBranch/loginExport",
    method: "get",
    params,
    responseType: "blob",
    headers: {
      Authorization: "",
      "Content-Type": "application/x-www-form-urlencoded"
    }
  });
};

export const Logout = (): Promise<ResponseData> => {
  return instance.request({
    url: "/logout",
    method: "get"
  });
};

export const GetExportCode = (): Promise<ResponseData> => {
  return instance.request({
    url: "/manage/insertBranch/exportCode",
    method: "get"
  });
};

// 获取登录日志
export const GetLoginList = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "POST",
    url: "/web/logoninfor/getLogoninforList",
    data
  });
};
// =================================================================================
// 获取登录指标
export const GetLoginTargetData = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/logoninfor/timePeriod",
    params
  });
};
// 获取登录占比
export const GetProportion = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/logoninfor/logonFrequency",
    params
  });
};
// 获取热门时间排行
export const GetPopularTime = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/logoninfor/hotTime",
    params
  });
};
// 获取今日数据
export const GetTodayData = (): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/web/logoninfor/today"
  });
};
// 获取终端地址
export const getTerminalUrl = (): Promise<ResponseData> => {
  return instance.request({
    method: "get",
    url: "/getJumpUrl"
  });
};

// 上传文件
export const uploadImage = (data: unknown, timeout?: number): Promise<ResponseData | void> => {
  return instance.request({
    method: "post",
    url: `/common/upload`,
    data,
    timeout,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
// 批量上传
export const batchUploadImage = (data: unknown, timeout?: number): Promise<ResponseData | void> => {
  return instance.request({
    method: "post",
    url: `/common/upload/batch`,
    data,
    timeout,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};
// 获取终端地址
export const getSystemDetails = (): Promise<ResponseData | void> => {
  return instance.request({
    method: "get",
    url: "/getSystemDetails",
    headers: {
      Authorization: ""
    }
  });
};

//保存用户跳转记录
export const saveSkipRecord = (data: unknown): Promise<ResponseData | void> => {
  return instance.request({
    method: "post",
    url: `/system/sso/saveSsoLog`,
    data
  });
};
